import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Azienda} from "../../Admin/models/Azienda";
import {ApiRestService} from "../api-rest.service";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ClassicType} from "../../shared/models/ClassicType";
import {Lavorazione, VoceAcquisto} from "../_Models";
import {Permission} from "../../Login/_guards/Permission";

@Component({
  selector: 'app-acquisti-aggiunte-edit',
  templateUrl: './acquisti-aggiunte-edit.component.html'
})
export class AcquistiAggiunteEditComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Input() VoceAcquisto: VoceAcquisto = new VoceAcquisto();
  @Input() fornitore: Azienda;
  @Input() vengoDa: 'acquisto' | 'ordine';
  @Output() Saved = new EventEmitter<VoceAcquisto>();
  environment = environment;
  prodotti: ClassicType[]=[];
  prodottiSelezionati: ClassicType[]=[];
  prodottoListino: any;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  prodottoBrandizzatoDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput:true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: false,
  };
  unitadropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  ListaProdottiBrandizzati: any[];
  ProdottoBrandizzato: any;
  constructor(
    private apiRestService: ApiRestService,
    private activeModalService: NgbActiveModal,
    private modalService: NgbModal,
    public permission: Permission,
    private toastService: ToastrService,
    private apiPaths: ApiPathsService,
  ) { }

  ngOnInit(): void {
    if(this.permission.HasCapacity(["gestione-acquisti"]) && this.fornitore?.id)
      this.filtroProdotti('');
    this.refresh();
  }





  refresh(){
    this.apiRestService.PrimaNotaAcquistiProdotti({page: 0, size: 10, fornitore: this.fornitore?.id?.toString()}).subscribe(data=> {this.prodotti = data;});
      if(this.VoceAcquisto?.id) {
      this.apiRestService.PrimaNotaAcquistiVoceGet({id:this.VoceAcquisto?.id}).subscribe(data=>{
        this.VoceAcquisto = data;
        this.Compile();
      })
    }
    else
     this.Compile();
  }


  Compile(){
    this.prodottiSelezionati = [];
    if (this.VoceAcquisto?.idProdottoNeutro > 0) {
      this.apiRestService.ProdottiListinoProdottiGet({id: this.VoceAcquisto?.idProdottoNeutro}).subscribe(data=> {
        this.ProdottoBrandizzato = this.VoceAcquisto?.prodottoObject;
        var prodottoNeutro = data?.data;
        prodottoNeutro.label = prodottoNeutro.prodotto;
        this.prodottiSelezionati = prodottoNeutro ? [prodottoNeutro] : [];
      });

    }
    else if(this.VoceAcquisto?.prodottoObject)
      this.prodottiSelezionati = [this.VoceAcquisto.prodottoObject];
  }


  getProdottiBrandizzati(codice:string){
    this.ListaProdottiBrandizzati = [];
    this.apiPaths.ClassicPost('/prodotti/list', {codice: codice, page: 0, size: 10}).subscribe(data => {
      this.ListaProdottiBrandizzati = data?.data?.map(data => {data.label = data.prodotto; return data}) ?? [];
      console.log("Prodotti Brandizzati: ",this.ListaProdottiBrandizzati);
    });
  }

  getAggiunte(){
    var id=  this.prodottiSelezionati?.find(x=>true)?.id;
    this.apiRestService.ProdottiListinoProdottiGet({id:id}).subscribe(data=> {
      this.prodottoListino = data?.data;
      this.VoceAcquisto.prezzo = !this.VoceAcquisto.id ?this.prodottoListino.prezzo : this.VoceAcquisto.prezzo;
      if(this.VoceAcquisto)
        this.prodottoListino?.aggiunte?.forEach(element => {
          element.selected = !this.VoceAcquisto?.id ? this.VoceAcquisto?.aggiunte?.find(x => x == element.id) != undefined || element.selected : this.VoceAcquisto?.aggiunte?.find(x => x == element.id) != undefined;
        })
    })
  }

  save() {
    if(this.prodottiSelezionati?.length > 0) {
      if (!this.ProdottoBrandizzato && this.prodottiSelezionati?.length > 0) {
        this.VoceAcquisto.voce = (this.VoceAcquisto.idProdottoNeutro ? this.VoceAcquisto.prodottoObject.label : this.prodottoListino?.prodotto ?? '') + this.getnomi(this.prodottoListino?.aggiunte?.filter(x => x?.selected)) + `, ${this.VoceAcquisto.aggiunta}`;
        this.VoceAcquisto.prodotto_id = this.VoceAcquisto.idProdottoNeutro ? this.VoceAcquisto.prodotto_id : this.prodottoListino?.prodotto_id;
        this.VoceAcquisto.prodottoObject = this.prodottiSelezionati?.length > 0 ? this.prodottiSelezionati[0] : undefined;
      }
      this.VoceAcquisto.aggiunte = this.prodottoListino?.aggiunte?.filter(x => x?.selected).map(y => y?.id);
      this.VoceAcquisto.voce_id = this.ProdottoBrandizzato?.id ?? this.prodottoListino?.id;
      this.VoceAcquisto.um_id = this.prodottoListino?.um;
    } else {
      this.VoceAcquisto.um_id = 64;
    }
    this.VoceAcquisto.iva = 0;
    this.Saved.emit(this.VoceAcquisto);
    this.close();
  }
  filtroProdotti(string){
    this.apiRestService.PrimaNotaAcquistiProdotti({page: 0, size: 10, fornitore: this.fornitore?.id?.toString()}).subscribe(data=>{
      this.prodotti = data;
    })
  }
  getnomi(data: any[]){
    var testo:string = "";
    data?.forEach(element=> testo = testo + ' , ' + element?.nome)
    return testo;
  }
  getprezzo(data: any[]){
    var prezzo: number = 0.0;
    data?.forEach(element=> prezzo = prezzo + parseFloat(element?.prezzo.toString()))
    return prezzo;
  }
  getprezzoComplessivo(){
    return parseFloat(this.VoceAcquisto.prezzo.toString()) + parseFloat(this.VoceAcquisto?.aggiuntaPrezzo?.toString()??'0') + parseFloat(this.getprezzo(this.prodottoListino?.aggiunte?.filter(x=> x?.selected)).toString())
  }

  close() {
    this.activeModalService.dismiss();
  }

  ProdottoSelected() {
    var prodotto = this.prodottiSelezionati?.find(x=>true);
    if(!prodotto || !this.permission.HasCapacity(['gestione-acquisti']) || !this.fornitore?.id ) return;
    this.VoceAcquisto.codProdotto = prodotto.label;
    this.getProdottiBrandizzati(this.VoceAcquisto.codProdotto);
    this.getAggiunte();

    if(this.ProdottoBrandizzato?.id) return;
    this.VoceAcquisto.brand = "Neutro";
    this.VoceAcquisto.brandizzato = false;
    this.ProdottoBrandizzato = undefined;

  }
  ProdottoBrandizzatoSelected(){
    if(!this.ProdottoBrandizzato) return;
    this.VoceAcquisto.voce = this.ProdottoBrandizzato.label + this.getnomi(this.prodottoListino?.aggiunte?.filter(x=> x?.selected));
    this.VoceAcquisto.brand = this.ProdottoBrandizzato.label.replace(this.VoceAcquisto.codProdotto,"");
    this.VoceAcquisto.brandizzato = true;
    this.VoceAcquisto.prodotto_id = this.ProdottoBrandizzato.id;
    this.VoceAcquisto.idProdottoNeutro = this.prodottiSelezionati[0]?.id;
    this.VoceAcquisto.prodottoObject = this.ProdottoBrandizzato;
    //this.getAggiunte();
  }



  stringanonvuota(item: string){
    return item != " " && item != "" && item != null
  }
  AddStock() {
    this.VoceAcquisto?.stockObject?.push(new Lavorazione(this.VoceAcquisto?.id))
  }
  AddProduzione() {
    this.VoceAcquisto?.produzioneObject?.push(new Lavorazione(this.VoceAcquisto?.id))
  }
  EditStock(item?: Lavorazione) {
    item.modifica = !item.modifica;
    item.backup = Object.assign({}, item);
    if(item.modifica ) return;
    if (this.stringanonvuota(item.data) && !isNaN(item.quantita)){
      if(item.id)
        this.apiRestService.PrimaNotaStockUpdate(item).subscribe(()=>{
          this.refresh();
        })
      else
        this.apiRestService.PrimaNotaStockAdd(item).subscribe(()=>{
          this.refresh();
        })
      // this.AggiunteChange.emit(this.Aggiunte);
      return;
    }
    if (!this.stringanonvuota(item.data))
      this.toastService.warning("inserire una data", "Attenzione!!");
    if (isNaN(item.quantita))
      this.toastService.warning("inserire la quantita", "Attenzione!!");
    item.modifica = !item.modifica;
  }
  DeleteStock(item?: Lavorazione) {
    if(item.modifica) {
      item.data = item.backup.data;
      item.quantita = item.backup.quantita;
      item.modifica = false;
    }
    else {
      if(item.id)
      this.apiRestService.PrimaNotaStockDelete(item).subscribe(()=>{
        this.refresh();
      })
      else {
        const idx: number = this.VoceAcquisto?.stockObject?.findIndex(x => x == item);
        if (idx > -1)
          this.VoceAcquisto?.stockObject?.splice(idx, 1);
        this.refresh();
      }
    }
  }
  EditProduzione(item?: Lavorazione) {
    item.modifica = !item.modifica;
    item.backup = Object.assign({}, item);
    if(item.modifica ) return;
    if (this.stringanonvuota(item.data) && !isNaN(item.quantita)){
      if(item.id)
        this.apiRestService.PrimaNotaProduzioneUpdate(item).subscribe(()=>{
          this.refresh();
        })
      else
        this.apiRestService.PrimaNotaProduzioneAdd(item).subscribe(()=>{
          this.refresh();
        })
      return;
    }
    if (!this.stringanonvuota(item.data))
      this.toastService.warning("inserire una data", "Attenzione!!");
    if (isNaN(item.quantita))
      this.toastService.warning("inserire la quantita", "Attenzione!!");
    item.modifica = !item.modifica;
  }
  DeleteProduzione(item?: Lavorazione) {
    if(item.modifica) {
      item.data = item.backup.data;
      item.quantita = item.backup.quantita;
      item.modifica = false;
    }
    else {
      if(item.id)
        this.apiRestService.PrimaNotaProduzioneDelete(item).subscribe(()=>{
          this.refresh();
        })
      else {
        const idx: number = this.VoceAcquisto?.produzioneObject?.findIndex(x => x == item);
        if (idx > -1)
          this.VoceAcquisto?.produzioneObject?.splice(idx, 1);
        this.refresh();
      }
    }
  }


}
import { Pipe, PipeTransform } from '@angular/core';
import {Aggiunta} from "../../listino/_Models";
import {ToastrService} from "ngx-toastr";
import {ListinoImportComponent} from "../../listino/listino-import/listino-import.component";
import {StockImportComponent} from "../stock-import/stock-import.component";
import {ProdImportComponent} from "../prod-import/prod-import.component";
import {ApiPathsService} from "../../api-paths.service";
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'myfilter',
  pure: false
})
export class forfilter implements PipeTransform {
  transform(items: any[], seeall: boolean): any {
    if (!items || seeall != false)
      return items;
    return items.filter(item => item.selected);
  }
}
